<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
 
export default {
  data(){
    return {
        
    }
  },
    mounted(){
    
        
  },
  
  methods:{
     
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width:100%;
  height:100vh;
  background: #D9D9D9;
}
 
</style>
